<template>
  <el-collapse v-model="selectorActive" accordion>
    <el-collapse-item name="hooks">
      <template slot="title">
        <h3>Hooks</h3>
      </template>
      <hook-selector :isFixed="selectorFixed" :isEditable="survey.isPreview"></hook-selector>
    </el-collapse-item>

    <el-collapse-item name="music-questions">
      <template slot="title">
        <h3>Music Questions</h3>
      </template>
      <music-question-selector :isFixed="selectorFixed" :isEditable="survey.isPreview"></music-question-selector>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapState } from 'vuex';

import HookSelector from '../selectors/HookSelector';
import MusicQuestionSelector from '../selectors/MusicQuestionSelector';

export default {
  name: 'QualitativeSelectorTab',
  components: {
    HookSelector,
    MusicQuestionSelector,
  },
  data: () => ({
    selectorActive: 'hooks',
  }),
  props: {
    selectorFixed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('surveybuilder', ['survey']),
  },
};
</script>



// WEBPACK FOOTER //
// MusicSelectorTab.vue?0566f747